import * as React from 'react';
import { withRouter, RouterProps } from 'react-router';
import { History } from 'history';
import { Alert } from 'reactstrap';
import { compose, Dispatch, bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { State } from '../../redux/state';
import actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import { withLocalization, LProps } from '../../utils/wrappers';
import { CompetitionPledge, CompetitionPledgeCategory, Entities, CompetitionEntityPledge } from '../../userApi';
import { StyleState } from '../../utils/styles';
import Stories from '../../shared/Stories';
import { makePledgeCategoryPath, Routes, getPledgeParams } from '../../utils/routerHelper';
import { asPage } from '../../utils/wrappers/asPage';
import { WaitingWhiteBox, WaitingPageContent } from '../../shared/WaitingPage';
import CompetitionEntityPledges from './CompetitionEntityPledges';
import PledgeStats from './PledgeStats';
import { estimatePointsAvailable, CompetitionPledges, getPledgePhoto, fallbackPledgePhotoOnError, isCloseOutSurveyPledge } from '../../utils/userApiHelper';
import InviteAFriendPledge from '../Dashboard/InviteAFriend';
import { Button } from 'reactstrap';
interface Props {
  initializePledgePage: (history: History) => void;
  pointsAvailable: number;
  pledgeID: number;
  completions: number;
  pointsEarned: number;
  initializingPledgePage: boolean;
  pledge: CompetitionPledge;
  pledgeCategory: CompetitionPledgeCategory;
  competitionEntityPledges: CompetitionEntityPledge[];
  entities: Entities;
}
const didPledgeIDUpdate = (nextProps: LProps<Props>, props: LProps<Props>) => {
  if (!props.pledge) return false;
  return props.pledgeID !== nextProps.pledgeID && !isNaN(nextProps.pledgeID);
};

const someDescriptionContent = (pledge: CompetitionPledge) => {
  return Boolean(pledge.assumptions) || !isEmpty(pledge.learnMoreLinks);
};

class PledgePage extends React.Component<LProps<Props> & RouterProps> {
  public componentWillMount() {
    const { initializePledgePage, history } = this.props;
    initializePledgePage(history);
  }

  public componentWillReceiveProps(nextProps: LProps<Props>) {
    if (didPledgeIDUpdate(nextProps, this.props)) {
      const { initializePledgePage, history } = this.props;
      initializePledgePage(history);
    }
  }

  public render() {
    const {
      t, pledge, pledgeCategory, initializingPledgePage,
      pointsAvailable, completions, pointsEarned
    } = this.props;
    if (initializingPledgePage) {
      return <WaitingPageContent />;
    }
    const photo = getPledgePhoto(pledge, pledgeCategory.name);
    const closeOutSurvey = isCloseOutSurveyPledge(pledge);
    const surveyLink = closeOutSurvey && pledge.learnMoreLinks && pledge.learnMoreLinks[0];
    const subtitle = closeOutSurvey
      ? t(
        'For {{points}} points, take our close-out survey so we can improve the next challenge. '
        + 'Open the form below, then return here to confirm you submitted it.',
        { points: pledge.points }
      )
      : pledge.description;
    return (
      <div id="pledge_page" className={closeOutSurvey ? 'cc__pledge_page--close_out_survey' : undefined}>
        <div>
          {!pledge &&
            <Alert
              color={StyleState.Danger}
            >{t('We could not find the requested competition pledge.')}</Alert>
          }
          <div className="cc__page__column_content">
            <div className="cc__page_column_content__one">
              {photo &&
                <div className="cc__pledge_photo_container">
                  {closeOutSurvey && surveyLink ? (
                    <a
                      className="cc__pledge_photo_link"
                      href={surveyLink[1]}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={surveyLink[0] || t('Open the survey')}
                    >
                      <img
                        src={photo}
                        alt={pledge.shortTitle}
                        title={surveyLink[0] || pledge.shortTitle}
                        onError={(e) => fallbackPledgePhotoOnError(e, pledgeCategory && pledgeCategory.name)}
                      />
                    </a>
                  ) : (
                    <img
                      src={photo}
                      alt={pledge.shortTitle}
                      title={pledge.shortTitle}
                      onError={(e) => fallbackPledgePhotoOnError(e, pledgeCategory && pledgeCategory.name)}
                    />
                  )}
                </div>
              }
              <div className="cc__pledge_page__header">
                <h1 className="cc__pledge_page__title">{pledge.shortTitle}</h1>
                {subtitle &&
                  <p className="cc__pledge_page__subtitle">{subtitle}</p>
                }
                {closeOutSurvey && surveyLink &&
                  <div className="cc__pledge_page__close_out_cta">
                    <Button
                      color="primary"
                      size="lg"
                      tag="a"
                      href={surveyLink[1]}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {surveyLink[0] || t('Open the survey')}
                    </Button>
                    <p className="cc__lighttext cc__pledge_page__close_out_hint">
                      {t('After you submit the form, scroll down to confirm here and earn your points.')}
                    </p>
                  </div>
                }
                {pointsAvailable === 0 &&
                  <h4 className="cc__lighttext cc__pledge_page__complete">
                    <img style={{ width: '28px' }} src="/assets/story/checkmark@2x.png" alt={t('action taken')} />&nbsp;
                    {t('Complete')}
                  </h4>
                }
                {pledgeCategory &&
                  <div className="cc__pledge_page__category">
                    <Link to={makePledgeCategoryPath(pledgeCategory.id, t)}>{pledgeCategory.name}</Link>
                  </div>
                }
              </div>
              {someDescriptionContent(pledge) && !closeOutSurvey &&
                <div id="cc__pledge_page__description">
                  {pledge.assumptions &&
                    <div>
                      <h6>{t('Assumptions')}</h6>
                      <div className="cc__lighttext">{pledge.assumptions}</div>
                    </div>
                  }
                  {(pledge.learnMoreLinks && pledge.learnMoreLinks.length > 0) &&
                    <div id="cc__pledge_page__learn_more">
                      <h6>{t('Learn More')}</h6>
                      <ul>
                        {pledge.learnMoreLinks.map((learnMoreLink, i) => (
                          <li key={i}>
                            <a href={learnMoreLink[1]} target="_blank" rel="noopener noreferrer">{learnMoreLink[0]}</a>
                          </li>
                        ))}
                      </ul>

                    </div>
                  }
                </div>
              }
              <div id="cc__pledge_page__stats">
                <PledgeStats
                  pointsEarned={pointsEarned}
                  pledge={pledge}
                  completions={completions}
                />
              </div>
              {!initializingPledgePage && <CompetitionEntityPledges pledge={pledge} />}
              {initializingPledgePage && <WaitingWhiteBox />}

              {!initializingPledgePage && pledge.uuid === CompetitionPledges.InviteAFriend &&
                <div className="cc__white_box" id="invite-friend" style={{ marginTop: '1rem' }}>
                  <InviteAFriendPledge />
                </div>
              }

              {!initializingPledgePage &&
                <Stories
                  showPrompt={
                    pledge.uuid !== CompetitionPledges.TakeSurvey &&
                    pledge.uuid !== CompetitionPledges.InviteAFriend
                  }
                  pledge={pledge}
                />
              }
              {initializingPledgePage &&
                <WaitingWhiteBox />
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State, ownProps: LProps<RouterProps>): Partial<Props> => {
  const initializingPledgePage = state.pendingRoute === Routes.Pledge;
  if (initializingPledgePage) {
    return {
      initializingPledgePage
    };
  }
  const pledgeID = getPledgeParams(ownProps.history.location, ownProps.i18n).competitionPledgeID;
  const pledge = selectors.currentPledge(state, ownProps);
  if (!pledge) return { initializingPledgePage: true, pledgeID };
  return {
    pledgeID,
    pledge,
    completions: state.userPledgeCompletions[pledge.id] || 0,
    pointsEarned: state.userPledgePoints[pledge.id] || 0,
    pointsAvailable: estimatePointsAvailable(state.userPledgeCompletions, pledge),
    pledgeCategory: selectors.currentPledgeCategory(state, ownProps),
    entities: selectors.getEntitiesWithCompetitionEntityPledges(state, ownProps)
  };
};
const mapDispatchToProps = (dispatch: Dispatch): Partial<Props> => bindActionCreators({
  initializePledgePage: actions.initializePledgePage
}, dispatch);

export default asPage({ isGrey: true, requiresCompetitionStart: true, requiresCompetitionVerification: true })(compose(
  withRouter,
  withLocalization('pledge'),
  connect(mapStateToProps, mapDispatchToProps)
)(PledgePage));
